import request from "@/utils/request";

export default function getAnnuFeeTimeOutDeviceByPage(params) {
  return request({
    url: `/device/agent/chargingPile/getAnnuFeeTimeOutDeviceByPage`,
    params,
  });
}
